import { isBlankParagraph, mapBlockSequences, withBlanksFolded } from '../draft/blocks';
import type { ClauseDraft, DraftBlock, DraftParagraph } from '../draft/types';

// a gap snaps to five steps of 24/7 pt, saved as whole points: 3, 7, 10, 14, 17
const SLOT_STEP_PT = 24 / 7;
const SLOT_STEPS = 5;

const slotOf = (spaceAfter: number) =>
  Math.round(Math.min(Math.round(spaceAfter / SLOT_STEP_PT), SLOT_STEPS) * SLOT_STEP_PT);

// a heading carries its own slot so it never falls back to the default heading margins
const slotted = (paragraph: DraftParagraph): DraftParagraph => {
  const lineSlot = slotOf(paragraph.spaceAfter ?? 0);
  return lineSlot > 0 || paragraph.role.kind === 'heading' ? { ...paragraph, lineSlot } : paragraph;
};

// a blank line typed under a heading widens the heading's gap instead of standing as a paragraph
const quantise = (blocks: DraftBlock[]): DraftBlock[] =>
  blocks.flatMap((block, index): DraftBlock[] => {
    if (block.kind !== 'paragraph' || block.spaceAfter === undefined) return [block];
    const previous = blocks[index - 1];
    if (isBlankParagraph(block) && previous?.kind === 'paragraph' && previous.role.kind === 'heading') return [];
    const next = blocks[index + 1];
    const foldsNext = block.role.kind === 'heading' && next?.kind === 'paragraph' && isBlankParagraph(next);
    return [slotted(foldsNext ? withBlanksFolded(block, [next]) : block)];
  });

export const quantiseSpacing = (draft: ClauseDraft): ClauseDraft => ({
  ...draft,
  blocks: mapBlockSequences(draft.blocks, quantise),
});
